var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrReg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 640,
    viewBox: "0 0 480 480",
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456 40v120h-88v-24c.04-33.96-13.43-66.54-37.44-90.56-1.918-1.922-3.84-3.68-5.84-5.44zm0 0",
    fill: "#7b7b7b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368 136v24H112v-24a127.65 127.65 0 0143.281-96c0-.078.078 0 .078 0 48.363-42.668 120.918-42.668 169.28 0 0 0 .078-.078.078 0 2 1.762 3.922 3.52 5.84 5.44A127.874 127.874 0 01368 136zm0 0",
    fill: "#adabac"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 40h131.28A127.65 127.65 0 00112 136v24H24zm40 152h48v216H64zm152 0h48v216h-48zm152 0h48v216h-48zm0 0",
    fill: "#7b7b7b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 432h432v16H24zM0 464h480v16H0zm40-64h96v16H40zm152 0h96v16h-96zm152 0h96v16h-96zM40 184h96v16H40zm152 0h96v16h-96zm152 0h96v16h-96zm-104-48c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40c-.027 22.082-17.918 39.973-40 40zm0-64c-13.254 0-24 10.746-24 24s10.746 24 24 24 24-10.746 24-24-10.746-24-24-24zm192 16h-16v-8h-8V64h16a8 8 0 018 8zM64 88H48V72a8 8 0 018-8h16v16h-8zm360 48h-16v-16h8v-8h16v16a8 8 0 01-8 8zm-352 0H56a8 8 0 01-8-8v-16h16v8h8zM0 152h480v16H0zm0 0",
    fill: "#4e4e4e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M464 40a8 8 0 00-8-8H328v.496c-50.668-43.328-125.332-43.328-176 0V32H24a8 8 0 00-8 8v112H0v16h480v-16h-16zm-16 112H32V48h104.496A135.304 135.304 0 00104 136h16c0-66.273 53.727-120 120-120s120 53.727 120 120h16a135.304 135.304 0 00-32.496-88H448zM24 432h432v16H24zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 464h480v16H0zm40-64v16h96v-16h-16V200h16v-16H40v16h16v200zm32-200h32v200H72zm120 200v16h96v-16h-16V200h16v-16h-96v16h16v200zm32-200h32v200h-32zm120 200v16h96v-16h-16V200h16v-16h-96v16h16v200zm32-200h32v200h-32zM240 56c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40c-.027-22.078-17.918-39.973-40-40zm0 64c-13.254 0-24-10.746-24-24s10.746-24 24-24 24 10.746 24 24-10.746 24-24 24zm176-32h16V72a8 8 0 00-8-8h-16v16h8zM48 72v16h16v-8h8V64H56a8 8 0 00-8 8zm384 56v-16h-16v8h-8v16h16a8 8 0 008-8zM64 112H48v16a8 8 0 008 8h16v-16h-8zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrReg);
export default __webpack_public_path__ + "static/media/strReg.39608f1a41bd4e3b5bad37adcbfbd03d.svg";
export { ForwardRef as ReactComponent };